<script>
import { Popup, List, Picker } from 'vant'
import CheckboxCard from '@/components/org/CheckboxCard'
import Common from '@/tbs/model/to/Common'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'checkbox-list-popup',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-popup': Popup,
        'van-list': List,
        'van-picker': Picker,
        'checkbox-card': CheckboxCard,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        show: Boolean,
        title: String,
        list: Array,
        max: Number,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: null,
            selectedList: [],
            locale: new Common
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        show(value) {
            this.showPopup = value
        },
    },
    
    //--------------------------------------------------
    // component mounted
    //--------------------------------------------------
    mounted() {
        this.showPopup = this.show
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onCancelBtnClick() {
            this.selectedList = []
            this.$emit('change-data', this.selectedList)
            this.showPopup = false
        },
        onConfirmBtnClick() {
            this.$emit('change-data', this.selectedList)
            this.selectedList = []
            this.showPopup = false
        },
        onCheckBoxCardDataChange(data) {
            console.log('onCheckBoxCardDataChange', data)
            if (data.opened) {
                this.selectedList.push(data.id)
            }
            else {
                const index = this.selectedList.indexOf(data.id)
                if (index > -1) {
                    this.selectedList.splice(index, 1)
                }
            }
        },
        validateSelectedRange(item) {
            // console.log('validateSelectedRange', JSON.stringify(item), JSON.stringify(this.selectedList))
             if (this.selectedList.length == this.max) {
                 if (this.selectedList.indexOf(item.id) == -1) {
                     return true
                 }
            }
            return false
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="checkbox-list-popup">
        <van-popup v-model="showPopup" position="bottom" @click-overlay="onCancelBtnClick">
            <div class="van-picker">
                <div class="van-picker__toolbar">
                    <button type="button" class="van-picker__cancel" @click="onCancelBtnClick">{{ locale['cancel'] }}</button>
                    <div class="van-ellipsis van-picker__title">{{ title }}</div>
                    <button type="button" class="van-picker__confirm" @click="onConfirmBtnClick">{{ locale['confirm'] }}</button>
                </div>
                <van-list class="popup-list">
                    <div v-for="item in list" :key="item.id" class="relative">
                        <checkbox-card 
                            :id="item.id"
                            :label="item.label" 
                            :subtext="item.subtext"
                            :disabled="validateSelectedRange(item)"
                            @change-data="onCheckBoxCardDataChange"
                        />
                        <div class="separator-line-bottom"/>
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>